<template>
    <el-main>
        <el-form class="el-form-search" label-width="120px">
            <el-form-item label="NFC编号：">
                <el-input size="small" v-model="searchForm.tag"></el-input>
            </el-form-item>
            <el-form-item label="MAC编号：">
                <el-input size="small" v-model="searchForm.mac"></el-input>
            </el-form-item>
            <el-form-item label="服务商姓名：">
                <el-input size="small" v-model="searchForm.name"></el-input>
            </el-form-item>
            <el-form-item label="绑定商家时间：">
                <el-date-picker size="small" v-model="searchForm.time" type="daterange" range-separator="至"
                    value-format="timestamp" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="店铺名称：">
                <el-input size="small" v-model="searchForm.store_name"></el-input>
            </el-form-item>
            <el-form-item label="设备状态：">
                <el-select v-model="searchForm.activate_status" size="small" placeholder="请选择">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option label="已激活" :value="1"></el-option>
                    <el-option label="未激活" :value="-1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" " label-width="25px">
                <el-button type="primary" size="small" @click="getDataList(1)">搜索</el-button>
                <el-button type="text" size="small" @click="clearSearch">清空搜索条件</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
            <template slot="empty">
                <No />
            </template>
            <el-table-column prop="tag" label="NFC编号" min-width="180" align="center"></el-table-column>
            <el-table-column prop="mac" label="充电线MAC编号" min-width="180" align="center"></el-table-column>
            <el-table-column prop="name" label="所属服务商姓名" min-width="180" align="center"></el-table-column>
            <el-table-column prop="store_name" label="店铺名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="mark" label="设备位置" min-width="180" align="center"></el-table-column>
            <el-table-column prop="activate_status" label="设备绑定状态" min-width="120" align="center">
                <template v-slot="{ row }">
                    <div :style="{ 'color': row.activate_status == 1 ? '#409EFF' : '#F56C6C' }">{{ row.activate_status == 1
                        ? '已激活' :
                        '未激活' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="绑定商家时间" align="center" min-width="200">
                <template v-slot="{ row }">
                    {{ getDateformat(row.binding_time) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="130">
                <template v-slot="{ row }">
                    <el-button type="text" size="small"
                        @click="$router.push({ path: '/extension/gatherTweeters/chargingOrder', query: { store_name: row.store_name } })">订单列表</el-button>
                </template>
            </el-table-column>
        </el-table>
        <Paging :total="total" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>
    </el-main>
</template>

<script>
import Paging from '@/components/paging.vue';
import { getDateformat } from '@/util/getDate.js'

export default {
    components: {
        Paging
    },
    data () {
        return {
            getDateformat,
            searchForm: {
                page: 1,
                rows: 10,
                tag: '',
                mac: '',
                activate_status: 0,
                name: '',
                store_name: '',
                time: '',
            },
            dataList: [],
            total: 0,
        }
    },
    created () {
        this.getDataList()
    },
    methods: {
        updateData (val, status) {
            if (status == 0) {
                this.searchForm.rows = val;
            } else {
                this.searchForm.page = val;
            }
            this.getDataList()
        },
        clearSearch () {
            this.searchForm = {
                page: 1,
                rows: 10,
                tag: '',
                mac: '',
                activate_status: 0,
                name: '',
                store_name: '',
                time: '',
            }
            this.getDataList(1)
        },
        getDataList (style) {
            if (style == 1) this.searchForm.page = 1

            let obj = { ... this.searchForm }
            if (obj.time) {
                obj.start_time = obj.time[0] / 1000
                obj.end_time = obj.time[1] / 1000
            }
            delete obj.time
            this.$axios.post(this.$api.serviceProvider.ChargeNfcList, obj)
                .then(res => {
                    if (res.code === 0) {
                        this.dataList = res.result.list
                        this.total = res.result.total_number
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
    }
}
</script>

<style lang="less" scoped>
.el-main {
    background-color: #fff;
}

.total-num {
    display: flex;
    font-weight: bold;
    margin: 20px 0;

    div {
        margin-right: 40px;
    }
}

.upload {
    margin-top: 20px;

    .el-button {
        position: relative;
        cursor: pointer;

        input {
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            right: 0;
            cursor: pointer;
        }
    }
}
</style>